{
  "version": 1,
  "asset_id": "ae75cf0b-ebfa-486e-b7d4-76fae654f3d9",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/ae75cf0b-ebfa-486e-b7d4-76fae654f3d9/forage-mofo-litigation-cert.jpg",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/ae75cf0b-ebfa-486e-b7d4-76fae654f3d9/forage-mofo-litigation-cert.jpg",
  "original_filename": "forage-mofo-litigation-cert.jpg",
  "size": 188276,
  "content_type": "image/jpeg",
  "created_at": "2026-07-22T06:50:25Z"
}
